// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".attendance-date span{display:none}.attendance-date.past{--tw-border-opacity:1;border-color:rgb(139 138 137 / var(--tw-border-opacity))}.attendance-date.past p{--tw-text-opacity:1;color:rgb(139 138 137 / var(--tw-text-opacity))}.attendance-date.past span{display:inline-block;transform:rotate(-31deg);width:3.7rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
